<template>
    <div class="uk-search uk-search-default" id="menu-search">
        <span uk-search-icon></span>
        <input v-model="search_input" class="uk-search-input" @input="doSearch" type="search" placeholder="">
        <div uk-dropdown="mode: click">
            <ul class="uk-nav uk-navbar-dropdown-nav">
                <li v-for="r in search_results">
                    <a :href="r.link">{{r.name}}</a>
                </li>
            </ul>
        </div>
    </div>

</template>

<script>
import api from '../../store/apicall.js'
import {debounce, throttle} from "@/utils/throttle";

export default {
	name: "menuSearch",
	data: function () {
		return {
			search_results: [],
			search_input: "",
			search_result_cutoff: 5,
		}
	},
	methods: {
		processSearchResults: function (results) {
			console.log(results)
			if (results.length > this.search_result_cutoff) {
				results = results.splice(0, this.search_result_cutoff);
			} else if (!resultls.length) {
				results = {'name': '..', 'link': '#'};

      }
			this.search_results = results
		},
		doSearch: function () {
			const _t = this;
			let triggersearch;
			let formData = new FormData();
			formData.append('q', _t.search_input);
			clearTimeout(triggersearch);
			triggersearch = setTimeout(() => {
				api.post('/search/', formData).then(
						function (response) {
							if (_t.search_input.length > 0) {
								_t.search_results = response.data;
							}
						}
				).catch(
						function (error) {
							console.log(error)
						}
				)
			}, 100)
		    },
	    }
    }
</script>

<style lang="less" scoped>
.uk-search{
    padding: 5px;
}
</style>
